import router from "./router";
import { ElMessage } from "element-plus";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import useUserStore from "@/store/modules/user";
import { useCacheH5RouteStore } from "@/store/modules/h5/cacheRoute.js";
import { getToken } from "@/utils/auth";
import { removeCache, cacheKeyList, addCache } from "@/utils/h5Cache.js";
import { isApp, callNativeFn } from "@/utils/appTools";
NProgress.configure({ showSpinner: false });
const whitePageList = [
  "/",
  "/localLogin",
  "/loginByPassword",
  "/loginByWechat",
  "/loginByCode",
  "/experience/login",
  "/regularExam/result",
  "/login",
  "/register",
  "/resetPassword",
  "/loginForLive",
  "/questionBank/index",
  "/h5/login",
  "/h5/loginAuth",
  "/regularExam/previewExam",
  "/stu-Play-live",
  "/h5/policy",
  "/h5/agreement",
  "/qa",
  "/examCenterDir/examAccountAnalysis",
  "/h5/mockInterviewTip",
];
const whiteParamPageList = ["/courseBrief/"]; // 可带参数的白名单页面
const h5WhitePageList = [ '/h5/result', '/h5/analysis'] // H5的白名单页面，请放在这里。下面处理了h5的缓存

router.beforeEach(async (to, from, next) => {
  if (to.query.clientSmsCode && !sessionStorage.getItem('__clientData__')) {
    sessionStorage.setItem('__clientData__', JSON.stringify({
      smsCode: to.query.clientSmsCode,
      href: to.href,
    }));
  }

  if (to.name == 'h5MockInterview' && !sessionStorage.getItem('__clientData__')) {
    next({ name: 'h5MockInterviewTip' });
    return;
  }
 
  NProgress.start();
  document.title = to.meta?.documentTitle || "仁和网校";
  if (
    whitePageList.includes(to.path) ||
    whiteParamPageList.some((s) => to.path.indexOf(s) > -1)
  ) {
    // 白名单页面，直接打开
    console.log('next01')
    handleH5Cache(to, from);
    return next();
  }
  if (h5WhitePageList.includes(to.path) ) { // h5 白名单页面，直接打开
    handleH5Cache(to, from);
    console.log('next02')
    return next();
  }
  const token = getToken();
  if (!token) {
    if (to.path.match(/^\/h5/)) {
      console.log("isApp", isApp());
      if (isApp()) {
        try {
          const res = await callNativeFn({ methodName: "getShortToken" });
          if (res.data) {
            setShortToken(res.data);
            console.log("isApp", res.data);
            handleH5Cache(to, from);
            console.log('next03')
            return next();
          }
        } catch (e) {}
      }
      console.log('next04')
      return next({
        path: "/h5/login",
        replace: true,
        query: {
          redirect: encodeURIComponent(to.fullPath),
        },
      });
    } else {
      console.log('next05')
      return next({
        path: "/login",
        replace: true,
        query: {
          redirect: encodeURIComponent(to.fullPath),
        },
      });
    }
  }
  if (!useUserStore().userInfo.id) {
    try {
      await useUserStore().getInfo();
      handleH5Cache(to, from);
      console.log('next06')
      next();
    } catch (e) {
      // 401已处理
    }
  } else {
    handleH5Cache(to, from);
    console.log('next07')
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});

function handleH5Cache(to, from) {
  const cacheH5RouteStore = useCacheH5RouteStore();
  if (!to.path.match(/^\/h5/)) {
    return;
  }
  if (from.meta?.keepCase?.length && from.meta.keepCase.includes(to.name)) {
    cacheH5RouteStore.addCacheName(from.name);
    from.meta.keepAlive = true;
  } else if (to.meta?.keepCase?.length) {
    cacheH5RouteStore.addCacheName(to.name);
    to.meta.keepAlive = true;
  } else {
    from.meta.keepAlive = false;

    //手动清除列表页缓存（关键！）
    if (cacheH5RouteStore.cacheNameList.includes(from.name)) {
      cacheH5RouteStore.removeCacheName(from.name);
    }
  }

  console.log('缓存函数处理后', cacheH5RouteStore.cacheNameList)
}

router.afterEach((to, from, next) => {
  try {
    const clientData = sessionStorage.getItem('__clientData__');
    $("html")
        .removeClass(
            ($("html")
                .attr("class")
                .match(/page-name-[^\s]+/) || [""])[0]
        )
        .addClass(`page-name-${to.name}`);
    $("html").removeClass("is-app-client");
    if (clientData) {
      $("html").addClass("is-app-client");
    }
  } catch (e) {}

  NProgress.done()
})
